import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import React from 'react';
import { Col, ControlLabel, Form, Row } from 'react-bootstrap';
import InfoButton from '../../../../../common/components/InfoButton';
import { HorizontalFormControl, InfoLabel } from '../../../../../common/components';
import SchemeManagementSectionContainer from '../../SchemeManagementSectionContainer/SchemeManagementSectionContainer';

const RatesForm = ({ show, isViewOnly, handleSubmit }) => {
  if (!show) {
    return null;
  }

  return (
    <SchemeManagementSectionContainer
      title={'Rates'}
      subTitle={'Conditions'}
      isViewOnly={isViewOnly}
      // formName={formName}
    >
      <Form horizontal onSubmit={handleSubmit}>
        <Row className={'section-item'}>
          <Col sm={12}>
            <ControlLabel>
              Extra Week Handling:&nbsp;
              <InfoButton
                content={
                  'Set the  additional day multiplier, for example if trip duration is over 53 days then for every 7 days over that duration apply the gte53 multiplier from the rates'
                }
              />
            </ControlLabel>
          </Col>
          <Col sm={6}>
            <Field
              name={'meta.patch.rates.base.conditions.trip_duration.key'}
              label="Trip duration:"
              labelSize={6}
              infoButton={
                <InfoButton
                  content={
                    'The number of days from which rates switch to a multiplier rate'
                  }
                />
              }
              component={isViewOnly ? InfoLabel : HorizontalFormControl}
            />
          </Col>
          <Col sm={6}>
            <Field
              name={'meta.patch.rates.base.conditions.trip_duration.value'}
              label="Extra Day Multiplier:"
              labelSize={6}
              infoButton={
                <InfoButton
                  content={'The number of days that the multipler with apply to'}
                />
              }
              //onChange={() => this.updateNumberFieldValue('meta.patch.parameters.max_age.max')}
              component={isViewOnly ? InfoLabel : HorizontalFormControl}
            />
          </Col>
        </Row>
      </Form>
    </SchemeManagementSectionContainer>
  );
};

export default compose(
  connect((state, props) => {
    return {
      formValues: getFormValues(props.formName)(state),
      destroyOnUnmount: false,
      enableReinitialize: true,
      form: props.formName,
    };
  }),
  reduxForm({}),
)(RatesForm);
